import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const ExchangeHealthcare = () => {
  const capabilities = [
    'Deploy standardized patient experience Training',
    'Add department-specific tracks',
    'Blend internal expertise with curated content',
    'Keep Training current as care models evolve'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gray-900/90 to-indigo-900/30 border border-cyan-500/30">
          <div className="flex items-start gap-6 mb-8">
            <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-lg flex-shrink-0 border border-cyan-500/30">
              <img 
                src="https://customer-assets.emergentagent.com/job_f6991d0e-ab71-4b45-956d-bb71024e7667/artifacts/yei0p5wf_Exchange%20Icon.png" 
                alt="Traain Exchange"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                Traain Exchange™
              </h2>
              <p className="text-xl text-cyan-400 font-semibold">
                Healthcare Training — Curated and Scalable
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8 leading-relaxed">
            Access a growing marketplace of healthcare-relevant Training while supporting internal programs.
          </p>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-white mb-4">Use Traain Exchange to:</h3>
            <div className="grid md:grid-cols-2 gap-4">
              {capabilities.map((capability, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-300">{capability}</span>
                </div>
              ))}
            </div>
          </div>

          <a href="/products/exchange">
            <Button
              variant="outline"
              className="border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400"
            >
              Learn More → Traain Exchange
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ExchangeHealthcare;
